import React from 'react';
import { Check } from 'lucide-react';
export function WorkWithMe() {
  const benefits = ['Sesiuni 1 la 1 online, într-un cadru sigur și confidențial', 'Lucru pe cei 3 piloni: Trecut, Prezent și Viitor', 'Tehnici NLP adaptate situației tale', 'Meditații ghidate pentru reglare emoțională', 'Mentorare și ghidare între sesiuni, pas cu pas'];
  return <section className="bg-white py-24 md:py-32" data-id="element-206">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-207">
        <div className="max-w-3xl mx-auto space-y-12" data-id="element-208">
          {/* Header */}
          <div className="text-center space-y-4" data-id="element-209">
            <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-210">
              Modalitatea de a lucra cu mine
            </h2>
            <p className="text-xl font-medium text-navy" data-id="element-211">
              Un singur format, profund și personalizat, pentru femeile care
              sunt gata de transformare reală.
            </p>
          </div>

          {/* Therapy image + Program Card unified */}
          <div className="rounded-2xl overflow-hidden border border-cardBorder" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/jiy4SJG4mcZrJ4pKY2Ymnh/Simona_Coaching.png" alt="Sesiune de terapie" className="w-full h-[300px] object-cover" data-id="element-213" />

            {/* Main Program Card */}
            <div className="bg-blush p-8 md:p-12 space-y-8" data-id="element-214">
              <div className="space-y-2 text-center border-b border-cardBorder pb-8" data-id="element-215">
                <h3 className="font-serif text-3xl font-medium text-magenta" data-id="element-216">
                  Program 1 la 1 Terapia T.P.V.
                </h3>
                <p className="text-sm font-medium tracking-widest uppercase text-muted" data-id="element-217">
                  Coaching & Vindecare Emoțională Personalizată
                </p>
              </div>

              <div className="space-y-4 pt-4" data-id="element-218">
                {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-219">
                    <Check className="w-6 h-6 text-cyan flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-220" />
                    <p className="text-base text-navy" data-id="element-221">{benefit}</p>
                  </div>)}
              </div>

              <div className="pt-8 text-center" data-id="element-222">
                <a href="https://project-wise-miso-279.magicpatterns.app/" className="inline-block bg-magenta text-white font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-cyan transition-colors duration-300 w-full md:w-auto text-center" data-id="element-223">
                  Vreau Programul 1 la 1
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}